import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../StyleSheet/MainComponent/Role/RoleCreate.scss";
import {
  setRoleRetrieveActions,
  setRoleEditActions,
  setPerformanceAction,
  setClientBranchActions, //--barnch
} from "../../../../Redux/Slice";
import Select from "react-select";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import useDebouncedEffect from "use-debounced-effect";

const RoleEdits = (props) => {
  const {
    setShow,
    show,
    currentPage,
    EditID,
    Datamonth,
    white_collar_List,
    search,
  } = props;
  const initialState = {
    role: "",
    description: "",
    perform_id: [],
    position_number: null,
    wages: "0",
    salary: "",
    white_collar: true,
    clien_id: "",
    from_salary: "0",
    to_salary: "0",
    wbs_element: null,
    wbs_description: null,
  };
  const [datas, setDatas] = useState(initialState);
  const [whitechanges, setwhitechnages] = useState(true);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const [wbs_elementerr, setWbserr] = useState("");
  const [wbsDexrip, setWbsDri] = useState("");

  const [vefied, setverified] = useState(0);
  const [RoleError, setRoleError] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [options, setOptions] = useState();
  const [multiselectState, setMuliStateselect] = useState([]);
  const initialStateSearch = {
    performsearhc: "",
    client: "",
  };

  const Swal = require("sweetalert2");

  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    performsearhc: "",
    client: "",
  };
  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  const [performErr, setPerformmerr] = useState();
  const [SelectedPerformdata, setSelectedPerform] = useState([]);
  const [ids, setIDs] = useState();
  const [nameList4, setOptions4] = useState([]);
  const [clientErr, setClientErr] = useState();
  const [salarerr, setSalaerr] = useState();
  const [wagesErr, setWageErr] = useState();
  const [selectwages, setwageSelect] = useState();
  const [clientSelectval, setclientSel] = useState();
  const [clientids, setselectIdc] = useState();
  const [whiteChe, setWhiteChe] = useState("");
  console.log(SelectedPerformdata, "SelectedPerformdata");
  const [wagetype, setwages] = useState([
    {
      value: "0",
      label: "DAILY",
    },
    {
      value: "1",
      label: "WEEKLY",
    },

    {
      value: "2",
      label: "MONTHLY",
      // selectwages,
    },
  ]);

  //---filter for Skill Assement Headers--------
  const [typeOfParent, setEmplyHeaders] = useState([
    {
      value: "Tech",
      label: "TECHNICAL",
    },
    {
      value: "soft",
      label: "SOFT SERVICES",
    },
  ]);

  const [EMpHeaderSelected, setEmpHeadersSele] = useState(typeOfParent[0]);

  const [typeOfperformance, setPerformances] = useState("Tech");

  ////----\Header--changes---
  const HandleHeaderrole = (e) => {
    if (e != null) {
      setEmpHeadersSele(e);
      setPerformances(e.value);

      if (
        e.value == "Tech" &&
        state.performanceTypeCall.performanceDatas != undefined
      ) {
        let objectArray = [];
        let ids = [];

        state.performanceTypeCall.performanceDatas.forEach((element) => {
          element.parent_type == "Tech" &&
            objectArray.push({
              value: element.id,
              label: element.grading_name,
            });

          element.parent_type == "Tech" && ids.push(element.id);
        });
        setSelectedPerform(objectArray);

        setOptions(objectArray);
        setDatas({
          ...datas,
          perform_id: ids,
        });
      }

      if (
        e.value == "soft" &&
        state.performanceTypeCall.performanceDatas != undefined
      ) {
        let objectArray = [];

        let ids = [];

        state.performanceTypeCall.performanceDatas.forEach((element) => {
          element.parent_type == "soft" &&
            objectArray.push({
              value: element.id,
              label: element.grading_name,
            });

          element.parent_type == "soft" && ids.push(element.id);
        });
        setOptions(objectArray);
        setSelectedPerform(objectArray);
        setDatas({
          ...datas,
          perform_id: ids,
        });
      }
    }
  };

  ////---Emp----Role--------------------------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "0",
      label: "UDS",
    },
    {
      value: "1",
      label: "CLIENT",
    },
  ]);

  const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const [from_salaryErro, seyFromsalaryerr] = useState("");
  const [tosalaryErr, settosalaryErr] = useState("");

  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);
      if (e.value == 0) {
        setDatas({
          ...datas,
          white_collar: true,

          clien_id: "",
          perform_id: [],
          from_salary: "0",
          to_salary: "0",
          wbs_element: "",
          wbs_description: "",
        });
        setSelectedPerform([]);
      } else {
        setDatas({
          ...datas,
          white_collar: false,
        });
      }
    }
  };

  const [projectErr, setProjectER] = useState("");

  const inputRef = useRef(null);
  const preventZoom = (event) => {
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "+" || event.key === "-" || event.type === "wheel")
    ) {
      event.preventDefault();
    }
    if (
      ["e", "E", "+", "-", "."].includes(event.key) ||
      event.key === "ArrowUp" ||
      event.key === "ArrowDown"
    ) {
      event.preventDefault();
    }
  };
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");
    const filtered = paste.replace(/[^0-9]/g, "");
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
  };
  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);
  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          performsearhc: SearchDebounance.performsearhc,
          client: SearchDebounance.client,
        });
      }
    },
    500,
    [SearchDebounance],
  );
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      performsearhc: Val,
    });
  };

  const handleInputChangeClinet = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      client: Val,
    });
  };
  useEffect(() => {
    const Ids = {
      EditID: EditID,
    };
    ///   console.log(state.roleRetrieve.RoleRetrieve  ,"afsd");
    dispatch(setRoleRetrieveActions(Ids));
  }, []);
  const HandleClientBranches = (selectedVal) => {
    console.log(selectedVal.value, "va;lusfodcn ");
    setclientSel(selectedVal);
    setDatas({
      ...datas,
      clien_id: selectedVal.value,
    });
    setselectIdc(selectedVal.value);
  };
  const Handlewages = (selectedVal) => {
    console.log(selectedVal.value, "va;lusfodcn ");
    setwageSelect(selectedVal);
    setDatas({
      ...datas,
      wages: selectedVal.value,
      salary: datas.salary,
      from_salary:
        selectedVal.value == 0
          ? datas.salary * 31
          : selectedVal.value == 1
            ? Math.round((datas.salary / 7) * 31)
            : datas.salary,
    });
  };

  ///---Performs0----
  useEffect(() => {
    const payload = {
      search: SearchedVal.performsearhc,
      page_size: 100,
      page: 1,
    };
    dispatch(setPerformanceAction(payload));
  }, [SearchedVal.performsearhc]);
  console.log(state.performanceTypeCall.performanceDatas, "performssdfcwd");
  useEffect(() => {
    const payload = {
      search: SearchedVal.client,
      page_size: 10,
      page: 1,
      client: "",
    };
    dispatch(setClientBranchActions(payload));
  }, [SearchedVal.client]);

  //----Options---
  useEffect(() => {
    if (state.performanceTypeCall.performanceDatas != undefined) {
      let objectArraysPerformances = [];
      let ids = [];

      state.performanceTypeCall.performanceDatas.forEach((element) => {
        element.parent_type == "Tech" &&
          objectArraysPerformances.push({
            value: element.id,
            label: element.grading_name,
          });

        element.parent_type == "Tech" && ids.push(element.id);
      });
      setOptions(objectArraysPerformances);
      setDatas({
        ...datas,
        perform_id: ids,
      });
      console.log(objectArraysPerformances, "objectArraysPerformances");

      setMuliStateselect(objectArraysPerformances);
      setSelectedPerform(objectArraysPerformances);
    }
  }, [state.performanceTypeCall.performanceDatas, SearchedVal.performsearhc]);

  useEffect(() => {
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      state.ClientBranch.ClientBranchess.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ClientBranch.ClientBranchess, SearchedVal.client]);

  ///---Changer----
  const handlePerform = (selectedVal) => {
    // console.log(selectedVal.value, "va;lusfodcn ");
    let ids = [];
    setSelectedPerform(selectedVal);

    setMuliStateselect(selectedVal);

    for (let i = 0; i < selectedVal.length; i++) {
      ids.push(selectedVal[i].value);
    }
    setIDs(ids);
    // setDatas({
    //   ...datas,
    //   perform_id: ids,
    // });
    // setPerformId({ ...Performsid, id: selectedVal.value });
    // console.log(ids, "ids");
  };

  useEffect(() => {
    if (state.roleRetrieve.RoleRetrieve.id) {
      setDatas({
        ...datas,
        role: state.roleRetrieve.RoleRetrieve.role,
        description: state.roleRetrieve.RoleRetrieve.description,
        perform_id: ids,
        position_number:
          state.roleRetrieve.RoleRetrieve.position_number == ""
            ? null
            : state.roleRetrieve.RoleRetrieve.position_number,
        salary: state.roleRetrieve.RoleRetrieve.salary,
        wages: state.roleRetrieve.RoleRetrieve.wages,
        clien_id: clientids,
        white_collar:
          state.roleRetrieve.RoleRetrieve.white_collar != null &&
          state.roleRetrieve.RoleRetrieve.white_collar == true
            ? state.roleRetrieve.RoleRetrieve.white_collar
            : false,

        from_salary: state.roleRetrieve.RoleRetrieve.from_salary,
        to_salary: state.roleRetrieve.RoleRetrieve.to_salary,
        wbs_element:
          state.roleRetrieve.RoleRetrieve.wbs_element == ""
            ? null
            : state.roleRetrieve.RoleRetrieve.wbs_element,
        wbs_description:
          state.roleRetrieve.RoleRetrieve.wbs_description == ""
            ? null
            : state.roleRetrieve.RoleRetrieve.wbs_description,
      });
      if (
        datas.white_collar != null &&
        datas.white_collar != undefined &&
        datas.white_collar
      ) {
        setEmpRoleSele(EmpRoles[0]);
      } else if (
        datas.white_collar != null &&
        datas.white_collar != undefined &&
        !datas.white_collar
      ) {
        setEmpRoleSele(EmpRoles[1]);
      }

      if (datas.wages == 0) {
        setwageSelect({
          value: "0",
          label: "DAILY",
        });
      } else if (datas.wages == 1) {
        setwageSelect({
          value: "1",
          label: "WEEKLY",
        });
      } else if (datas.wages == 2) {
        setwageSelect({
          value: "2",
          label: "MONTHLY",
        });
      }
    }
  }, [state.roleRetrieve.RoleRetrieve, ids, clientids]);
  // console.log(datas, "weuew ofc ");
  useEffect(() => {
    if (
      state.roleRetrieve.RoleRetrieve.client_id != null &&
      state.roleRetrieve.RoleRetrieve.client_id != undefined
    ) {
      setclientSel({
        value: state.roleRetrieve.RoleRetrieve.client_id.id,
        label: state.roleRetrieve.RoleRetrieve.client_id.client_name,
      });
      setselectIdc(state.roleRetrieve.RoleRetrieve.client_id.id);
    }
  }, [state.roleRetrieve.RoleRetrieve]);
  // console.log(datas, "rfcdicfgwrgc", clientids);
  useEffect(() => {
    if (
      state.roleRetrieve.RoleRetrieve != undefined &&
      state.roleRetrieve.RoleRetrieve.perform_id != undefined
    ) {
      let Array = [];
      let id_fetch = [];

      state.roleRetrieve.RoleRetrieve.perform_id.forEach((element) => {
        Array.push({
          value: element.id,
          label: element.grading_name.toUpperCase(),
        });
        id_fetch.push(element.id);
      });
      setIDs(id_fetch);
      // console.log(Array, "Array");
      setSelectedPerform(Array);
    }
  }, [state.roleRetrieve.RoleRetrieve]);

  const handleClose = () => {
    Swal.fire({
      title: `Do you want to Exit ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setShow(false);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };
  const HandleChanges = (e, values) => {
    // setDatas((prev) => {
    //   return {
    //     ...prev,
    //     [e.target.name]: e.target.value,
    //   };
    // });

    if (e.target.name == "white_collar") {
      const { name, value } = e.target;
      setDatas({
        ...datas,
        [name]: values,
      });
    } else if (e.target.name != "white_collar") {
      const { name, value } = e.target;
      setDatas({
        ...datas,
        [name]: value,
      });
    }

    if (e.target.name == "salary") {
      const { name, value } = e.target;

      setDatas({
        ...datas,
        salary: value,
        from_salary:
          datas.wages == 0
            ? value * 31
            : datas.wages == 1
              ? Math.round((value / 7) * 31)
              : value,
      });
    }
  };

  console.log(datas, "3i59en lkdatas");
  const HandleSubmit = () => {
    // console.log(datas, "datas", datas.wages, "yscfiwe");
    var a = 0;
    if (datas.role == "") {
      a = 1;
      setRoleError("*Designation is Required");
    }
    if (datas.description == "") {
      a = 1;
      setDescriptionError("*Descriptions is required");
    }
    //   if(datas.white_collar == true){
    //   if (datas.perform_id == "") {
    //     setPerformmerr("*Perform is required");
    //     a = 1;
    //   }
    // }

    // if (datas.position_number == "" || datas.position_number == null) {
    //   a = 1;
    //   setProjectER("*Position Number is required");
    // }

    if (datas.white_collar == false) {
      if (datas.clien_id == "") {
        setClientErr("*Client Branch is required");
        a = 1;
      }
    }
    if (datas.white_collar == false) {
      // if (datas.wbs_element == "" || datas.wbs_element == undefined) {
      //   setWbserr("*Wbs Element is required");
      //   a = 1;
      // }
      // if (datas.wbs_description == "" || datas.wbs_description == undefined) {
      //   setWbsDri("*Wbs Description is required");
      //   a = 1;
      // }
    }

    if (datas.white_collar == false) {
      if (datas.from_salary == "") {
        seyFromsalaryerr("*From salary is required");
        a = 1;
      }
      if (datas.to_salary == "") {
        settosalaryErr("*To salary is required");
        a = 1;
      }
    }

    if (datas.salary == "") {
      setSalaerr("*Salary is required");
      a = 1;
    }
    if (datas.wawagesges == "") {
      setWageErr("*Wages Type is required");
      a = 1;
    }

    if (a == 0 && vefied == 0) {
      // console.log(datas ,"inner");

      Swal.fire({
        title: `Do you want to save the changes?`,
        // text: "You won't be able to revert this",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f26639",
        cancelButtonColor: "#F69338",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            datas: datas,
            EditID: EditID,
            currentPage: currentPage,
            white_collar: state.NumberCounts.Rolechanges == 1 ? true : false,
            month: Datamonth.month,
            year: Datamonth.year,
            search: search,
            white_collar_List: white_collar_List,
          };
          dispatch(setRoleEditActions(payload, props.setShow()));
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    }
  };
  const HandleSubmits = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
        <div className="col BodyContent">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div class="ModalHeader">
                      <span className="UserCreate"> Designation </span>

                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>

                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div class="col-sm-3 mt-3 field-div">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Employee Designation
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          {/* <input
                            type="checkbox"
                            //value={"true"}
                             style={{marginLeft:"15px"}}

                            name="white_collar"


                            // class="form-control"
                            // autoComplete="off"
                            // value={datas.white_collar}
                            onChange={(e) => {
                              setwhitechnages(!whitechanges)
                              HandleChanges(e , whitechanges);
                              setWhiteChe("");
                            }}
                        
                             checked={datas.white_collar}
                         
                            
                          ></input> */}

                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                              HandleEMprole(e);
                              setWhiteChe("");
                            }}
                            value={EMpROleSelected}
                            options={EmpRoles}
                            placeholder="search"
                            isDisabled
                          />

                          <p style={{ color: "red", marginTop: "5px" }}>
                            {whiteChe}
                          </p>
                        </div>

                        <div class="col-sm-3  mt-3 field-div">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Designation
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={datas.role}
                            autoComplete="off"
                            onChange={(e) => {
                              HandleChanges(e);
                              setRoleError("");
                            }}
                            required
                            name="role"
                            style={{
                              padding: "10px",
                              //borderRadius: "12px",
                            }}
                          ></input>
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {RoleError}
                          </p>
                        </div>
                        {/* </div>
                        <div className="row"> */}
                        <div class="col-sm-3 mt-3 ">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Position Number
                            {/* <span style={{ color: "red" }}>*</span> */}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            autoComplete="off"
                            value={
                              datas.position_number != "" &&
                              datas.position_number != null &&
                              datas.position_number != undefined
                                ? datas.position_number.slice(0, 20)
                                : datas.position_number
                            }
                            onChange={(e) => {
                              HandleChanges(e);
                              if (e.target.value.length > 20) {
                                setProjectER(
                                  "*Project Number should not exit 20 characters",
                                );
                              } else {
                                setProjectER("");
                              }
                            }}
                            name="position_number"
                            required
                            style={{
                              padding: "10px",
                            }}
                          ></input>
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {projectErr}
                          </p>
                        </div>
                        {!datas.white_collar ? (
                          <>
                            <div class="col-sm-3  mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                                style={{ fontSize: "15px" }}
                              >
                                Wbs Element
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                value={datas.wbs_element}
                                autoComplete="off"
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setWbserr("");
                                }}
                                required
                                name="wbs_element"
                                style={{
                                  padding: "10px",
                                }}
                              ></input>
                              <p style={{ color: "red", marginTop: "5px" }}>
                                {wbs_elementerr}
                              </p>
                            </div>

                            <div class="col-sm-3  mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                                style={{ fontSize: "15px" }}
                              >
                                Wbs Description
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                value={datas.wbs_description}
                                autoComplete="off"
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setWbsDri("");
                                }}
                                required
                                name="wbs_description"
                                style={{
                                  padding: "10px",
                                }}
                              ></input>
                              <p style={{ color: "red", marginTop: "5px" }}>
                                {wbsDexrip}
                              </p>
                            </div>
                          </>
                        ) : null}

                        <div className="col-sm-3 mt-3 WagesType">
                          <label for="validationCustom01" class="form-label">
                            Wages Type
                          </label>
                          <span style={{ color: "red" }}>*</span>
                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                              Handlewages(e);
                              setWageErr("");
                            }}
                            options={wagetype}
                            placeholder="search"
                            value={selectwages}
                          />
                          <p
                            style={{
                              color: "red",
                              marginTop: "5px",
                              marginLeft: "2px",
                            }}
                          >
                            {wagesErr}
                          </p>
                        </div>

                        <div class="col-sm-3 mt-3 field-div">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Salary
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            autoComplete="off"
                            value={datas.salary}
                            // onChange={(e) => {
                            //   // HandleChanges(e);
                            //   // setSalaerr("");

                            //   HandleChanges(e);
                            //   if (e.target.value.length > 20) {
                            //     setSalaerr(
                            //       "*Salary should not exceed 20 digits"
                            //     );
                            //     setverified(1);
                            //   } else {
                            //     setSalaerr("");
                            //     setverified(0);
                            //   }
                            // }}

                            onChange={(e) => {
                              const inputValue = parseFloat(e.target.value);
                              if (inputValue <= 0) {
                                setSalaerr("*salary must be greater than 0.");
                                setverified(1);
                                e.target.value = "";
                              } else {
                                setSalaerr("");
                                setverified(0);
                                HandleChanges(e);
                              }
                            }}
                            onInput={(e) => {
                              const inputValue = parseFloat(e.target.value);
                              if (inputValue <= 0) {
                                setSalaerr("*salary must be greater than 0.");
                                setverified(1);
                                e.target.value = "";
                              } else {
                                setSalaerr("");
                                setverified(0);
                                HandleChanges(e);
                              }
                            }}
                            onKeyDown={preventZoom}
                            onPaste={handlePaste}
                            onWheel={preventwheel}
                            ref={inputRef}
                            name="salary"
                            required
                            style={{
                              padding: "10px",
                            }}
                          ></input>
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {salarerr}
                          </p>
                        </div>
                        {datas.white_collar == false ? (
                          <div
                            className="col-sm-3"
                            style={{ marginTop: "-15px", marginBottom: "10px" }}
                          >
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ marginTop: "7px" }}
                              >
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  Salary
                                </label>
                              </div>
                              <div
                                className="row"
                                style={{
                                  marginLeft: "5px",
                                  display: "flex",
                                  marginRight: "2px",
                                }}
                              >
                                <div className="col">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    From
                                  </label>
                                  <input
                                    type="number"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="from_salary"
                                    value={datas.from_salary}
                                    // onChange={(e) => {
                                    //   HandleChanges(e);
                                    //   seyFromsalaryerr("");
                                    // }}
                                    onChange={(e) => {
                                      const inputValue = parseFloat(
                                        e.target.value,
                                      );
                                      if (inputValue <= 0) {
                                        seyFromsalaryerr(
                                          "* From salary must be greater than 0.",
                                        );
                                        setverified(1);
                                        e.target.value = "";
                                      } else {
                                        seyFromsalaryerr("");
                                        setverified(0);
                                        HandleChanges(e);
                                      }
                                    }}
                                    onInput={(e) => {
                                      if (e.target.value.length > 15) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          15,
                                        );
                                      }
                                      const inputValue = parseFloat(
                                        e.target.value,
                                      );
                                      if (inputValue <= 0) {
                                        seyFromsalaryerr(
                                          "* From salary must be greater than 0.",
                                        );
                                        setverified(1);
                                        e.target.value = "";
                                      } else {
                                        seyFromsalaryerr("");
                                        setverified(0);
                                        HandleChanges(e);
                                      }
                                    }}
                                    onKeyDown={preventZoom}
                                    onPaste={handlePaste}
                                    onWheel={preventwheel}
                                    ref={inputRef}
                                  />
                                  <p className="Error">{from_salaryErro}</p>
                                </div>

                                <div className="col">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    To
                                  </label>
                                  <input
                                    type="number"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="to_salary"
                                    value={datas.to_salary}
                                    onChange={(e) => {
                                      // HandleChanges(e);
                                      // settosalaryErr("");

                                      HandleChanges(e);
                                      const toSalary = e.target.value;
                                      const fromSalary = datas.from_salary;
                                      settosalaryErr("");

                                      if (
                                        Number(toSalary) < Number(fromSalary)
                                      ) {
                                        setverified(1);

                                        settosalaryErr(
                                          "*The 'To Salary' should not be less than the 'From Salary'.",
                                        );
                                      } else {
                                        settosalaryErr("");
                                        setverified(0);
                                      }
                                    }}
                                    onInput={(e) => {
                                      if (e.target.value.length > 15) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          15,
                                        );
                                      }
                                    }}
                                    onKeyDown={preventZoom}
                                    onPaste={handlePaste}
                                    onWheel={preventwheel}
                                    ref={inputRef}
                                  />
                                  <p className="Error">{tosalaryErr}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>

                      <div className="row">
                        {datas.white_collar == false ? (
                          <div className="col-sm-3 mt-1 field-div">
                            <label for="validationCustom01" class="form-label">
                              Client Name
                            </label>
                            <span style={{ color: "red" }}>*</span>
                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                HandleClientBranches(e);
                                setClientErr("");
                              }}
                              options={nameList4}
                              onInputChange={handleInputChangeClinet}
                              placeholder="search"
                              value={clientSelectval}
                            />
                            <p
                              style={{
                                color: "red",
                                marginTop: "5px",
                                marginLeft: "2px",
                              }}
                            >
                              {clientErr}
                            </p>
                          </div>
                        ) : null}

                        {datas.white_collar == false ? (
                          <div className="col-sm-3 mt-1 field-div">
                            <label htmlFor="points">
                              Type of Header
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              onChange={(e) => {
                                HandleHeaderrole(e);
                              }}
                              value={EMpHeaderSelected}
                              options={typeOfParent}
                              placeholder="search"
                            />
                          </div>
                        ) : null}

                        {datas.white_collar == false ? (
                          <div class="col-sm-3 mt-3 field-div" id="RoleCreate">
                            <label
                              for="validationCustom02"
                              class="form-label"
                              style={{ fontSize: "15px", width: "195px" }}
                            >
                              Performance
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            {/* <div className="Performance"> */}
                            <Select
                              className="Selects"
                              style={{
                                fontSize: "12px",
                                margin: "auto",
                                chips: {
                                  background: "#4D9BD7",
                                  borderRadius: "3px",
                                },
                                option: {
                                  color: "black",
                                  backgroundColor: "white",
                                },
                                inputField: {
                                  margin: "-5px 5px",
                                  height: "40px",
                                },
                                searchBox: {
                                  padding: "5px",
                                  height: "70px",
                                  overflow: "auto",
                                },
                              }}
                              // options={options}

                              // className="Selects"
                              value={SelectedPerformdata}
                              onSelect={(e) => setMuliStateselect(e)}
                              onChange={(e) => {
                                handlePerform(e);
                                setPerformmerr("");
                              }}
                              isMulti
                              options={options}
                              onInputChange={handleInputChange}
                              labelledBy="Select"
                            />
                            {/* </div> */}

                            <p
                              style={{
                                color: "red",
                              }}
                            >
                              {performErr}
                            </p>
                          </div>
                        ) : null}
                        <div class="col-sm-3 mt-3 field-div">
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Description
                          </label>
                          <textarea
                            type="text"
                            class="form-control"
                            autoComplete="off"
                            value={datas.description}
                            onChange={(e) => {
                              HandleChanges(e);
                              setDescriptionError("");
                            }}
                            name="description"
                            required
                            style={{
                              padding: "10px",
                              height: "60%",
                              // borderRadius: "12px",
                            }}
                          ></textarea>
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {DescriptionError}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="RoleButton"
                      style={{
                        display: "flex",
                        gap: "15px",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        marginTop: "20px",
                        padding: "20px",
                      }}
                    >
                      <button
                        class="  CancelBtn ButtonCSS"
                        type="submit"
                        onClick={HandleSubmit}
                      >
                        Update Form
                      </button>

                      <button
                        class=" CancelBtn ButtonCSS"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleEdits;
